import { createTokenQueryServiceInstance } from 'src/app/core/services/query.service';
import { SignalStoreConfig } from 'src/app/shared/functions/store.functions';
import { QueryState } from 'src/app/core/models/query.model';

//CONFIGURAZIONE PER ESTRARRE IL JSON DEL FORM
export const JSON_FORM_ENDPOINT = 'jsonForm';
export const JSON_FORM_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(JSON_FORM_ENDPOINT);


export const jsonFormStateConfig: SignalStoreConfig<QueryState<any>> = {
    initState: {
      list: []
    }
  }

//CONFIGURAZIONE PER EFFETTUARE LE OPEZIONI DI CRUD SUL FORM FLUX
export const  CRUD_FORM_FLUX_ENDPOINT = 'forms';
export const  CRUD_FORM_FLUX_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(CRUD_FORM_FLUX_ENDPOINT);

//CONFIGURAZIONE PER EFFETTUARE LE OPEZIONI DI CRUD SUL FORM
export const  CRUD_FORM_ENDPOINT = 'form';
export const  CRUD_FORM__QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(CRUD_FORM_ENDPOINT);


//CONFIGURAZIONE PER EFFETTUARE LE OPEZIONI DI CRUD SUI FILE
export const  CRUD_FILE_ENDPOINT = 'file';
export const  CRUD_FILE_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(CRUD_FILE_ENDPOINT);

export const  GET_DATA_FORM_ENDPOINT = 'form/byIdPsa';

export const crudFormStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}